'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$29(ps$56) {
  this.a75 = null;
  this.a75 = ps$56;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$29 as $c_Lmealorama_jsonCodecs$package$$anon$29 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$29.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$29;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$29() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$29 as $h_Lmealorama_jsonCodecs$package$$anon$29 };
$h_Lmealorama_jsonCodecs$package$$anon$29.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a75.a.length;
});
$p.g = (function(i) {
  return this.a75.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$29 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$29, "mealorama.jsonCodecs$package$$anon$29", ({
  JR: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$29 as $d_Lmealorama_jsonCodecs$package$$anon$29 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$29.js.map
